
(function() {
  function initFacetFilter() {
    var bar = document.getElementById('facet-filter-bar');
    if (!bar || bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';


  const STOREFRONT_TOKEN = document.getElementById('facet-filter-bar').dataset.storefrontToken;
  const SHOP_DOMAIN = document.getElementById('facet-filter-bar').dataset.shopDomain;
  const COLLECTION_HANDLE = document.getElementById('facet-filter-bar').dataset.collectionHandle;
  const STOREFRONT_URL = `${window.location.origin}/api/2024-01/graphql.json`;

  // Active filters state
  const state = {
    metal: new Set(),
    type: new Set(),
    priceMin: null,
    priceMax: null,
    cursor: null,
  };

  // Available facet values (populated from first query)
  let facetValues = { metal: {}, type: {} };

  // GQL query
  function buildQuery(filters, cursor) {
    const filterArgs = [];
    if (filters.metal.size > 0) {
      [...filters.metal].forEach(m => {
        filterArgs.push(`{productMetafield: {namespace: "custom", key: "metal", value: "${m}"}}`);
      });
    }
    if (filters.type.size > 0) {
      [...filters.type].forEach(t => {
        filterArgs.push(`{productMetafield: {namespace: "custom", key: "jewelry_type", value: "${t}"}}`);
      });
    }
    if (filters.priceMin !== null || filters.priceMax !== null) {
      const min = filters.priceMin !== null ? filters.priceMin : 0;
      const max = filters.priceMax !== null ? filters.priceMax : 999999;
      filterArgs.push(`{price: {min: ${min}, max: ${max}}}`);
    }
    const filterStr = filterArgs.length > 0 ? `, filters: [${filterArgs.join(',')}]` : '';
    const afterStr = cursor ? `, after: "${cursor}"` : '';

    return `{
      collection(handle: "${COLLECTION_HANDLE}") {
        handle
        products(first: 48, sortKey: TITLE${filterStr}${afterStr}) {
          filters {
            id label type
            values { id label count input }
          }
          edges {
            node {
              id title handle
              priceRangeV2 {
                minVariantPrice { amount }
                maxVariantPrice { amount }
              }
              featuredImage { url(transform: {maxWidth: 400, maxHeight: 400}) altText }
              metafield(namespace: "custom", key: "metal") { value }
            }
          }
          pageInfo { hasNextPage endCursor }
        }
      }
    }`;
  }

  async function fetchProducts() {
    document.getElementById('facet-loading').removeAttribute('hidden');

    try {
      const res = await fetch(STOREFRONT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query: buildQuery(state) }),
      });

      const data = await res.json();
      const products = data?.data?.collection?.products;
      const filters = data?.data?.collection?.products?.filters || [];

      if (products) {
        renderProducts(products.edges, products.pageInfo);
        updateFacetValues(filters);
        updateResultCount(products.edges.length);
      }
    } catch(e) {
      console.error('Facet filter error:', e);
    } finally {
      document.getElementById('facet-loading').setAttribute('hidden', '');
    }
  }

  function renderProducts(edges, pageInfo) {
    const grid = document.getElementById('facet-product-grid');
    if (edges.length === 0) {
      grid.innerHTML = '<div class="facet-no-results">No products match your filters.</div>';
      return;
    }

    const cards = edges.map(({ node: p }) => {
      const minPrice = parseFloat(p.priceRangeV2.minVariantPrice.amount);
      const maxPrice = parseFloat(p.priceRangeV2.maxVariantPrice.amount);
      const priceStr = minPrice === maxPrice
        ? `$${minPrice.toFixed(2)}`
        : `<span class="facet-card-price-range">From </span>$${minPrice.toFixed(2)}`;
      const img = p.featuredImage
        ? `<img src="${p.featuredImage.url}" alt="${p.featuredImage.altText || p.title}" loading="lazy">`
        : `<div style="aspect-ratio:1;background:#f5f5f5;"></div>`;

      return `<a href="/products/${p.handle}" class="facet-product-card" style="text-decoration:none;color:inherit;">
        ${img}
        <div class="facet-card-body">
          <p class="facet-card-title">${p.title}</p>
          <p class="facet-card-price">${priceStr}</p>
        </div>
      </a>`;
    }).join('');

    grid.innerHTML = `<div class="facet-grid">${cards}</div>`;
  }

  function updateFacetValues(filters) {
    // Populate metal options
    const metalFilter = filters.find(f => f.id === 'filter.p.m.custom.metal');
    if (metalFilter) {
      const container = document.getElementById('facet-metal-options');
      container.innerHTML = metalFilter.values.map(v => `
        <label class="facet-option">
          <input type="checkbox" value="${v.label}" data-facet="metal" ${state.metal.has(v.label) ? 'checked' : ''}>
          ${v.label} <span style="color:#aaa;font-size:11px;">(${v.count})</span>
        </label>
      `).join('');
      container.querySelectorAll('input').forEach(cb => {
        cb.addEventListener('change', () => {
          if (cb.checked) state.metal.add(cb.value);
          else state.metal.delete(cb.value);
          updatePills();
          updateButtonStates();
          fetchProducts();
        });
      });
    }

    // Populate type options
    const typeFilter = filters.find(f => f.id === 'filter.p.m.custom.jewelry_type');
    if (typeFilter) {
      const container = document.getElementById('facet-type-options');
      container.innerHTML = typeFilter.values.map(v => `
        <label class="facet-option">
          <input type="checkbox" value="${v.label}" data-facet="type" ${state.type.has(v.label) ? 'checked' : ''}>
          ${v.label} <span style="color:#aaa;font-size:11px;">(${v.count})</span>
        </label>
      `).join('');
      container.querySelectorAll('input').forEach(cb => {
        cb.addEventListener('change', () => {
          if (cb.checked) state.type.add(cb.value);
          else state.type.delete(cb.value);
          updatePills();
          updateButtonStates();
          fetchProducts();
        });
      });
    }
  }

  function updatePills() {
    const container = document.getElementById('facet-active-pills');
    const clearAll = document.getElementById('facet-clear-all');
    const pills = [];

    state.metal.forEach(v => pills.push({ facet: 'metal', value: v }));
    state.type.forEach(v => pills.push({ facet: 'type', value: v }));
    if (state.priceMin !== null || state.priceMax !== null) {
      const label = `$${state.priceMin || 0} – $${state.priceMax || '∞'}`;
      pills.push({ facet: 'price', value: label });
    }

    container.innerHTML = pills.map(p =>
      `<span class="facet-pill" data-facet="${p.facet}" data-value="${p.value}">
        ${p.value} ✕
      </span>`
    ).join('');

    container.querySelectorAll('.facet-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        const { facet, value } = pill.dataset;
        if (facet === 'metal') state.metal.delete(value);
        else if (facet === 'type') state.type.delete(value);
        else if (facet === 'price') { state.priceMin = null; state.priceMax = null; }
        updatePills();
        updateButtonStates();
        fetchProducts();
      });
    });

    clearAll.hidden = pills.length === 0;
  }

  function updateButtonStates() {
    document.querySelector('[data-facet="metal"] .facet-btn').classList.toggle('has-selection', state.metal.size > 0);
    document.querySelector('[data-facet="type"] .facet-btn').classList.toggle('has-selection', state.type.size > 0);
    document.querySelector('[data-facet="price"] .facet-btn').classList.toggle('has-selection', state.priceMin !== null || state.priceMax !== null);

    const metalCount = state.metal.size > 0 ? `(${state.metal.size})` : '';
    const typeCount = state.type.size > 0 ? `(${state.type.size})` : '';
    document.querySelector('[data-facet="metal"] .facet-count').textContent = metalCount;
    document.querySelector('[data-facet="type"] .facet-count').textContent = typeCount;
  }

  function updateResultCount(count) {
    document.getElementById('facet-result-count').textContent = `${count} products`;
  }

  // Dropdown toggle
  document.querySelectorAll('.facet-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const group = btn.closest('.facet-group');
      const dropdown = group.querySelector('.facet-dropdown');
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      // Close all others
      document.querySelectorAll('.facet-dropdown').forEach(d => d.hidden = true);
      document.querySelectorAll('.facet-btn').forEach(b => b.setAttribute('aria-expanded', 'false'));

      if (!isOpen) {
        dropdown.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close on outside click
  document.addEventListener('click', () => {
    document.querySelectorAll('.facet-dropdown').forEach(d => d.hidden = true);
    document.querySelectorAll('.facet-btn').forEach(b => b.setAttribute('aria-expanded', 'false'));
  });

  // Price apply
  document.querySelector('.facet-apply-price').addEventListener('click', () => {
    const min = document.getElementById('facet-price-min').value;
    const max = document.getElementById('facet-price-max').value;
    state.priceMin = min ? parseFloat(min) : null;
    state.priceMax = max ? parseFloat(max) : null;
    updatePills();
    updateButtonStates();
    fetchProducts();
  });

  // Clear all
  document.getElementById('facet-clear-all').addEventListener('click', () => {
    state.metal.clear();
    state.type.clear();
    state.priceMin = null;
    state.priceMax = null;
    document.getElementById('facet-price-min').value = '';
    document.getElementById('facet-price-max').value = '';
    updatePills();
    updateButtonStates();
    fetchProducts();
  });

  // Initial load
  fetchProducts();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFacetFilter);
  } else {
    initFacetFilter();
  }
  // Re-init on Shopify AJAX section render
  document.addEventListener('shopify:section:load', initFacetFilter);
})();
